import { motion } from "framer-motion";
import { Feather } from "lucide-react";
import { ASSETS, MISSION_STATEMENT } from "@/data/content";

const MissionSection = () => {
    return (
        <section id="mission" data-testid="mission-section" className="relative overflow-hidden py-24 sm:py-32">
            <div className="pointer-events-none absolute inset-0" aria-hidden="true">
                <div className="absolute -left-32 top-1/4 h-[420px] w-[420px] rounded-full bg-[#7200C8]/20 blur-[150px]" />
                <div className="absolute -right-24 bottom-0 h-[380px] w-[380px] rounded-full bg-[#D9A441]/10 blur-[140px]" />
            </div>

            <div className="relative mx-auto grid max-w-7xl items-center gap-14 px-5 lg:grid-cols-[1fr_1.2fr] lg:gap-20 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, x: -40 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                    className="relative mx-auto w-full max-w-md"
                >
                    <div className="absolute -inset-6 rounded-full bg-[#7200C8]/20 blur-3xl" aria-hidden="true" />
                    <div className="relative rounded-3xl border border-[#D9A441]/30 bg-[#0B0E18]/70 p-10 backdrop-blur-xl">
                        <img
                            data-testid="mission-logo"
                            src={ASSETS.monogramQuill}
                            alt="BrothaTruth interlocking BT logo with a gold quill feather"
                            className="mx-auto w-full max-w-[260px] drop-shadow-[0_0_30px_rgba(217,164,65,0.35)]"
                            loading="lazy"
                        />
                        <div className="gold-hairline mx-auto mt-8 h-px w-2/3" />
                        <div className="mt-6 flex items-center justify-center gap-3 text-[#D9A441]">
                            <Feather className="h-5 w-5 animate-float-soft" />
                            <span className="font-display text-xs uppercase tracking-[0.3em]">Est. on Truth</span>
                        </div>
                    </div>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, x: 40 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                >
                    <div className="flex items-center gap-4">
                        <span className="gold-hairline h-px w-14" />
                        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#D9A441]">Our Mission</p>
                    </div>
                    <h2 data-testid="mission-heading" className="mt-6 font-display text-3xl font-bold leading-tight tracking-tight text-[#F8F5EE] sm:text-4xl lg:text-5xl">
                        Real Knowledge. <br />
                        Real Solutions. <br />
                        <span className="text-gold-gradient">Real Impact.</span>
                    </h2>
                    <p data-testid="mission-statement" className="mt-7 max-w-xl border-l-2 border-[#D9A441]/60 pl-6 text-base leading-relaxed text-[#F8F5EE]/70 sm:text-lg">
                        {MISSION_STATEMENT}
                    </p>
                </motion.div>
            </div>
        </section>
    );
};

export default MissionSection;
